<template>
  <div class="home">
    <!-- <router-view/> -->
    <menuList></menuList>
    <div class="content" :style="{minHeight:minHeight+'px'}">
      <router-view/>
    </div>
    <div class="alter flex-vc" v-if="!ischrome">
      <a href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank" class="black-font font-size14">推荐使用谷歌浏览器Chrome访问，点<span class="green-font">这里下载</span></a>
    </div>

  </div>

</template>

<script>
  import menuList from './components/menu'
  export default {
    //name: 'operate',
    data () {
      return {
          minHeight:window.innerHeight - 70,
          ischrome:true,
      }
    },
    components:{
      menuList,
    },
    methods:{
      getinfo(){
        var agent = navigator.userAgent.toLowerCase();
        var regStr_ie = /msie [\d.]+;/gi ;
        var regStr_ff = /firefox\/[\d.]+/gi
        var regStr_chrome = /chrome\/[\d.]+/gi ;
        var regStr_saf = /safari\/[\d.]+/gi ;
        //IE
        if(agent.indexOf("msie") > 0)
        {
          return agent.match(regStr_ie) ;
        }
        //firefox
        if(agent.indexOf("firefox") > 0)
        {
          return agent.match(regStr_ff) ;
        }
        //Safari
        if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0)
        {
          return agent.match(regStr_saf) ;
        }
        //Chrome
        if(agent.indexOf("chrome") > 0)
        {
          return agent.match(regStr_chrome) ;
        }
      }
    },
    mounted(){
        // console.log(this.getinfo());
        this.ischrome=this.getinfo()[0].indexOf('chrome')==-1 ? false : true;
        // if(this.getinfo()[0].indexOf('chrome')==-1){
        //   this.$notify({
        //     title: '提示',
        //     message: '推荐使用谷歌浏览器Chrome访问，点这里下载"https://www.google.cn/intl/zh-CN/chrome/"',
        //     duration: 0,
        //     showClose:false,
        //   });
        //   // this.$message('推荐使用谷歌浏览器Chrome访问，点这里下载"https://www.google.cn/intl/zh-CN/chrome/"');
        // }
      if(!this.ischrome){
        setTimeout(()=>{
          this.ischrome=true
        },10000)
      }
    },

  }
</script>

<style>
  .home{
    width:100%;
  }
  .content {
      padding: 12px 15px 0 15px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background: #eef2f2;
    margin-left: 200px;
    margin-top: 70px;
  }
  .alter{
    width: 340px;
    height: 50px;
    position: fixed;
    top:70px;
    right:40px;
    background: #ffffff;
    z-index: 20002;
    box-shadow: 0 0 10px #eeeeee;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/operate.vue